import React, {Component} from 'react';

class AppInstaller extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
        <div style = {{height: "600px",lineHeight: "1.1", overflow: "scroll"}}>
            <header>
                <h1><center style={{padding: "10px 10px 10px 10px", fontSize: "0.46em"}}>Smart Growth Diary</center></h1>
            </header>
            <main style={{padding: "10px 10px 10px 10px"}}>
                <p>Hivi karibuni utaweka programu ya SmartGD kwenye simu yako,</p>
                <p>Ujumbe wa kuweka utatokea hapa chini kwenye huu ukurasa,<br/> Tafadhali subiri kwa muda usiozidi dakika 2, itategemeana na muunganiko wa intaneti yako.</p>
                <p>Bonyeza ujumbe ulioandikwa "<font style={{color: "#0000ff"}}>Add SmartGD to Home screen</font>" ili kuweka hii programu kwenye simu yako.</p>
            </main>
            <hr/>
            <main style={{padding: "10px 10px 10px 10px"}}>
                <p>You will soon be installing the SmartGD aplication on your phone,</p>
                <p>Installation popup will appear at the bottom of this page,<br/> Please wait for not more than 2 minutes, it depends on your internet connection.</p>
                <p>Click "<font style={{color: "#0000ff"}}>Add SmartGD to Home screen</font>" popup to install this application on your phone.</p>
            </main>
        </div>
    );
  }
}

export default AppInstaller;